export default {
  skeletonContainer: {
    padding: '16px',
  },
  circleSkeletonContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
};
